import React from 'react'


const Select = ({value}) => {
    return value
}

export default Select